<div>
  <div class="box">
    <div class="drag-handle" cdkDragHandle>
      <button (click)="onClickListaCapas()" class="circle-button">
        <div class="button-icon">
          <img *ngIf="this.layerCatalogService.isExternalLayersVisible" [src]="'icon_capas_externas.svg' | findUrl" class="img-button">
          <img *ngIf="!this.layerCatalogService.isExternalLayersVisible" [src]="'icon_capas_externas_gris.svg' | findUrl" class="img-button">
        </div>
      </button>
    </div>
    <div [@mostrarLista]="this.layerCatalogService.isExternalLayersVisible ? 'visible' : 'hidden'" class="switch-list" [ngClass]="{'overflowHidden': this.panelExternalLayerService.isExpandCollapseAnimating}">
      <div class="tool-title">
        <mat-icon (click)="toggleExternalLayers()" class="expand-icon" [ngClass]="{'expanded': this.panelExternalLayerService.isExternalLayersExpanded}">expand_more</mat-icon>
        <h2>Capas Externas</h2>
        <!-- <mat-icon class="close-button" matTooltip="Cerrar" aria-hidden="false"  fontIcon="cancel" (click)="ClosePanel()"></mat-icon> -->
      </div>
      <div [@expandCollapseLayers]="this.panelExternalLayerService.isExternalLayersExpanded ? 'expanded' : 'collapsed'" (@expandCollapseLayers.start)="onExpandCollapseStart($event)" (@expandCollapseLayers.done)="onExpandCollapseDone($event)" class="switch-container">
        <div *ngFor="let capa of $capas" class="switch-item">
          <label class="switch col-3" [id]=capa.name>
            <img *ngIf="capa.checked" [src]="'btn_on.svg' | findUrl" class="img-button" (click)="onToggleLayer(capa.name)">
            <img *ngIf="!capa.checked" [src]="'btn_off.svg' | findUrl" class="img-button" (click)="onToggleLayer(capa.name)">
          </label>
          <span class="col-6">
            <!-- <img [src]="capa.icon | findUrl" class="img-layer"> -->
            {{ capa.name }}
          </span>
          <div class="switch-loading col-3">
              <loading [isLoading]="capa.isLoading" [isAbsolute]="false"></loading>
            </div>
        </div>
      </div>
  </div>
  </div>
</div>